import {
  AutoStack,
  DayPickerStrings,
  FormikGraphQLDatePicker,
  onFormatDate,
} from 'components'
import { Field, FieldArray, FieldProps } from 'formik'
import { FormikCheckbox } from 'formik-office-ui-fabric-react'
import { FieldStack, FieldStackItem, FormStack } from 'forms/FormStack'
import { Box } from 'grid'
import { UsageTimeSpan } from 'model'
import {
  DayOfWeek,
  DefaultButton,
  IconButton,
  Label,
} from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import * as Yup from 'yup'

export const usageTimespanSchema = Yup.object().shape({
  external: Yup.bool(),
  usageTimespans: Yup.array().when('external', {
    is: true,
    then: Yup.array()
      .of(
        Yup.object({
          dateFrom: Yup.date().required(),
          dateTo: Yup.date().required(),
        })
      )
      .min(1),
  }),
})

export const UsageTimespanForm: React.FC = () => {
  const { t } = useTranslation()
  const [isExternal, setExternal] = React.useState(false)

  const resetUsageTimespans = React.useCallback(
    (fieldProps: FieldProps<any>) => {
      const timeSpans = fieldProps.form.values.usageTimespans
      if (timeSpans && timeSpans.length > 0) {
        fieldProps.form.setFieldValue('usageTimespans', [])
      }
    },
    []
  )

  return (
    <FormStack>
      <FieldStack>
        <FieldStackItem
          stack={{ grow: 0 }}
          name="external"
          render={(fieldProps) => {
            setExternal(fieldProps.field.value)
            if (
              !fieldProps.field.value &&
              fieldProps.form.values.usageTimespans !== undefined
            ) {
              resetUsageTimespans(fieldProps)
            }
            return (
              <>
                <Label>{t('field.external.label')}</Label>
                <Box py={1}>
                  <FormikCheckbox {...fieldProps} />
                </Box>
              </>
            )
          }}
        />
        {isExternal && (
          <>
            <FieldArray name="usageTimespans">
              {({ form, name, ...helpers }) => {
                const values: UsageTimeSpan[] = form.values[name] || []

                return (
                  <AutoStack tokens={{ childrenGap: 4 }}>
                    {values.map((x, i: any) => (
                      <AutoStack
                        horizontal={true}
                        verticalAlign="center"
                        tokens={{ childrenGap: 8 }}
                        key={i}
                      >
                        <Field
                          name={`usageTimespans[${i}].dateFrom`}
                          component={FormikGraphQLDatePicker}
                          firstDayOfWeek={DayOfWeek.Monday}
                          strings={DayPickerStrings}
                          showWeekNumbers={true}
                          formatDate={onFormatDate}
                        />
                        <Field
                          name={`usageTimespans[${i}].dateTo`}
                          component={FormikGraphQLDatePicker}
                          initialPickerDate={new Date(x.dateFrom)}
                          firstDayOfWeek={DayOfWeek.Monday}
                          minDate={new Date(x.dateFrom)}
                          disables={!x.dateFrom}
                          strings={DayPickerStrings}
                          showWeekNumbers={true}
                          formatDate={onFormatDate}
                        />
                        {
                          <IconButton
                            styles={{ root: { color: 'red' } }}
                            iconProps={{ iconName: 'Delete' }}
                            onClick={() => helpers.remove(i)}
                          />
                        }
                      </AutoStack>
                    ))}
                    {values.length < 10 && (
                      <DefaultButton
                        iconProps={{ iconName: 'Add' }}
                        onClick={() => helpers.push({})}
                        text={`Zeitraum hinzufügen (noch ${
                          10 - values.length
                        })`}
                      />
                    )}
                  </AutoStack>
                )
              }}
            </FieldArray>
          </>
        )}
      </FieldStack>
    </FormStack>
  )
}
